import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Field, Input, Select } from '@itds/elements/index.js';
import Api from '@carrier/utils/Api';

const General = ({ loadVendor, vendor }) => {
  const [saving, setSaving] = useState(false);
  const [data, setData] = useState({
    name: vendor.name,
    url: vendor.url,
    business_type: vendor.business_type
  });

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleSave = () => {
    setSaving(true);

    Api.updateVendor(vendor.id, data).then(() => {
      loadVendor('save');
      setSaving(false);
    });
  };

  return (
    <>
      <Field label='Name'>
        <Input onChange={handleInputChange.bind(null, 'name')} value={data.name} />
      </Field>

      <Field label='Website URL'>
        <Input onChange={handleInputChange.bind(null, 'url')} value={data.url} />
      </Field>

      <Field label='Business Type'>
        <Select
          onChange={handleInputChange.bind(null, 'business_type')}
          options={[
            { value: 'Comparison Aggregator' },
            { value: 'Digital Marketer' },
            { value: 'IMO/BGA' },
            { value: 'Captive Agency' },
            { value: 'Carrier Tool' },
            { value: 'Other' }
          ]}
          value={data.business_type}
        />
      </Field>

      <div style={{ marginTop: 30 }}>
        <Button
          disabled={saving}
          // icon={saving ? 'loading mdi-spin' : null}
          inline={true}
          onClick={handleSave}
        >
          {saving ? 'Saving...' : 'Save Changes'}
        </Button>
      </div>
    </>
  );
};

General.propTypes = {
  loadVendor: PropTypes.func,
  vendor: PropTypes.object
};

export default General;
